import { Notification } from '../interfaces/Notification';
import apiService from './api.service';

class NotificationService {
  // Cache per le notifiche
  private notificationsCache: { data: Notification[] | null; timestamp: number } = {
    data: null,
    timestamp: 0
  };
  private CACHE_DURATION = 5 * 60 * 1000; // 5 minuti

  // Ottieni tutte le notifiche
  async getNotifications(forceRefresh = false): Promise<Notification[]> {
    if (!forceRefresh && this.notificationsCache.data &&
        Date.now() - this.notificationsCache.timestamp < this.CACHE_DURATION) {
      return this.notificationsCache.data;
    }

    const response = await apiService.get('/auth/profile/notifications/');
    
    // Verifica che la risposta contenga i dati attesi
    if (!response.data || !response.data.results) {
      throw new Error('Invalid API response structure for notifications');
    }

    const notificationsList: Notification[] = response.data.results || [];

    // Salva in cache
    this.notificationsCache = {
      data: notificationsList,
      timestamp: Date.now()
    };

    return notificationsList;
  }

  // Marca una notifica come letta
  async markAsRead(notificationId: number): Promise<void> {
    await apiService.patch(`/auth/profile/notifications/${notificationId}/read/`);
    
    // Invalida la cache per forzare un refresh
    this.notificationsCache = { data: null, timestamp: 0 };
  }

  // Marca tutte le notifiche come lette
  async markAllAsRead(): Promise<void> {
    await apiService.post('/auth/profile/notifications/read-all/');
    
    // Invalida la cache per forzare un refresh
    this.notificationsCache = { data: null, timestamp: 0 };
  }

  // Invalida la cache
  clearCache(): void {
    this.notificationsCache = { data: null, timestamp: 0 };
  }
}

// Esporta istanza singleton
const notificationService = new NotificationService();
export default notificationService;
